export function mountTenantOnboardLink(tenant: App.Tenant, token: string, region: string) {
  switch (tenant.brand) {
    case 'leagenthub':
      return `${
        window.configs.LEAGENTHUB_CUSTOMER_PORTAL
      }/${region}/agent-hub/complete-account-setup?token=${encodeURIComponent(token)}`;
    case 'leagenthub_cvfr':
      return `${
        window.configs.LEAGENTHUB_CVFR_CUSTOMER_PORTAL
      }/${region}/cvfr-holidays/complete-account-setup?token=${encodeURIComponent(token)}`;
    default:
      return '';
  }
}

export function isAgentHubSubBrand(brand: App.Brands) {
  return brand === 'leagenthub' || brand === 'leagenthub_cvfr';
}

export function isAgentHubSubTenant(tenant: App.Tenant) {
  return isAgentHubSubBrand(tenant.brand);
}
